<template>
  <v-container fluid tag="section">
    <validation-observer v-slot="{ valid }">
      <material-wizard
        v-model="tab"
        title="Salvar Análise Setorizada"
        subtitle="Selecione uma setorização e efetue análises dos itens presentes dentro dos setores gerados."
        :available-steps="availableSteps"
        :tabs="tabs"
        class="mx-auto"
        :loading="loading"
        :disabledBtnFinalizar="disabledBtnFinalizar"
        @click:next="next(valid)"
        @click:prev="tab--"
      >
        <v-tab-item class="pb-1">
          <form @submit.prevent="next(valid)">
            <first-tab-content ref="FirstTabContent" :items="analise" @data:updated="handleTabContentUpdated" />
          </form>
        </v-tab-item>
        <v-tab-item class="pb-1">
          <second-tab-content
            :month="analise.data"
            :items="analise"
            :filtrosSelecionados="[filtro]"
            :campoSelecionadoCalculo="campo"
            :bdgdVersion="analise.bdgdVersion"
            @data:updated="handleTabContentUpdated"
          />
        </v-tab-item>
        <v-tab-item class="pb-1">
          <third-tab-content
            :colors="analise.cores"
            :midpoint="analise.setorizacao.numero_setores"
            @data:updated="handleTabContentUpdated"
          />
        </v-tab-item>
      </material-wizard>
    </validation-observer>
  </v-container>
</template>

<script>
  import AnalisesSetorizadasService from '@/services/AnalisesSetorizadasService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      MaterialWizard: () => import('@/components/base/MaterialWizard'),
      FirstTabContent: () => import('@/components/analises-setorizadas/tabs/FirstTabContent.vue'),
      SecondTabContent: () => import('@/components/analises-setorizadas/tabs/SecondTabContent.vue'),
      ThirdTabContent: () => import('@/components/analises-setorizadas/tabs/ThirdTabContent.vue')
    },
    mixins: [dateFormatterMixins],
    data: () => ({
      tab: 0,
      tabs: ['Setorização', 'Filtre itens', 'Selecione cores'],
      basesLiberadasCampos: {},
      loading: false,
      analise: {
        id: null,
        nome: null,
        data: null,
        mes: null,
        bdgdVersion: null,
        setorizacao: {
          id: null,
          numero_setores: 0
        },
        basesSelecionadas: [],
        campoCalculoSelecionado: {
          funcao: 'SOMAR',
          campo: ''
        },
        filtros: {},
        cores: {
          corInicio: '#A2F19F',
          corFim: '#037A02'
        }
      },
      filtro: [],
      campo: {}
    }),
    computed: {
      availableSteps() {
        let steps = [];

        if (this.tab1IsValid) {
          steps.push(0);
        }

        if (this.tab2IsValid) {
          steps.push(1);
        }

        if (this.tab3IsValid) {
          steps.push(2);
        }

        return steps;
      },

      tab1IsValid() {
        const { nome, mes, bdgdVersion, setorizacao } = this.analise;

        return nome !== null && mes !== null && bdgdVersion !== null && setorizacao && setorizacao.id > 0;
      },

      tab2IsValid() {
        const { basesSelecionadas, campoCalculoSelecionado } = this.analise;

        return (
          this.tab1IsValid && basesSelecionadas.length > 0 && campoCalculoSelecionado.funcao && campoCalculoSelecionado.campo
        );
      },

      tab3IsValid() {
        const { cores } = this.analise;

        return this.tab1IsValid && this.tab2IsValid && cores.corInicio && cores.corFim && cores.corInicio !== cores.corFim;
      },

      disabledBtnFinalizar() {
        if (this.tab === 0) return !this.tab1IsValid;
        if (this.tab === 1) return !this.tab2IsValid;
        if (this.tab === 2) return !this.tab3IsValid;
        return true;
      }
    },
    mounted() {
      if (this.$route.params.id) this.carregarAnaliseSetorizada(this.$route.params.id);
    },
    methods: {
      async next(valid) {
        if (!valid) return;

        if (this.tab === 0 && !this.tab1IsValid) {
          return;
        }

        if (this.tab === 1 && !this.tab2IsValid) {
          return;
        }

        if (this.tab === 2) {
          if (!this.tab3IsValid) {
            return;
          }

          const sucesso = await this.salvarAnaliseSetorizada();
          if (!sucesso) {
            return;
          }

          this.$router.push({
            name: routes.state.appRoutes['ANALISES_SETORIZADAS_HISTORICO']
          });
        } else {
          this.tab++;
        }
      },

      handleTabContentUpdated(event) {
        this.analise = Object.assign(this.analise, event);
      },

      async salvarAnaliseSetorizada() {
        let sucesso = false;
        this.loading = true;

        try {
          const {
            nome,
            basesSelecionadas,
            campoCalculoSelecionado,
            filtros,
            cores,
            data,
            bdgdVersion,
            setorizacao,
            basesLiberadasCampos
          } = this.analise;

          let analise = {
            nome,
            id: this.$route.params.id ? this.$route.params.id : null,
            bases_dados_geograficas_config: JSON.stringify(basesSelecionadas),
            campo_config: JSON.stringify(campoCalculoSelecionado),
            filtros_config: JSON.stringify(filtros),
            cores_config: JSON.stringify(cores),
            setorizacao_id: setorizacao.id,
            data_registro: data,
            versao: bdgdVersion,
            bases_liberadas_campos: JSON.stringify(basesLiberadasCampos)
          };

          sucesso = await AnalisesSetorizadasService.save(analise);

          this.$toast.success('Análise Setorizada salva com sucesso.', '', {
            position: 'topRight'
          });
        } catch (e) {
          this.$toast.error('Erro ao salvar a análise setorizada.', '', {
            position: 'topRight'
          });
          console.log(e);
        } finally {
          this.loading = false;
        }

        return sucesso;
      },

      carregarAnaliseSetorizada(id) {
        this.loading = true;

        AnalisesSetorizadasService.getAnaliseSetorizada(id)
          .then((response) => {
            const setorizacaoData = response.data.data;

            this.analise = {
              id: setorizacaoData.id,
              nome: setorizacaoData.nome,
              data: setorizacaoData.mes,
              mes: this.formatMonthToPicker(setorizacaoData.mes),
              bdgdVersion: setorizacaoData.versao,
              setorizacao: setorizacaoData.setorizacao,
              basesSelecionadas: setorizacaoData.bases,
              basesGeograficas: setorizacaoData.bases_dados_geograficas,
              campoCalculoSelecionado: setorizacaoData.campo,
              filtros: setorizacaoData.filtros,
              cores: setorizacaoData.cores,
              basesLiberadasCampos: setorizacaoData.bases_liberadas_campos
            };

            this.filtro = setorizacaoData.filtros;
            this.campo = setorizacaoData.campo;
          })
          .catch((e) => {
            this.$toast.error('Erro ao carregar os dados da analise setorizada.', '', { position: 'topRight' });
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
            if (this.$refs.FirstTabContent) this.$refs.FirstTabContent.fillInputs();
          });
      }
    }
  };
</script>
